module.exports = __webpack_public_path__ + "img/xsfw_zf.ec790111.png";